import "../../../constants/index.js";
import { transformWithSpec } from "../../../utils/response.js";
import { ReferralCommissionSettingsSpec } from "../../../types/models/referral.specs.js";
function publicReferralEndpoints(builder) {
  return {
    getPublicReferralInfo: builder.query({
      providesTags: ["referral"],
      query: () => ({
        url: `/referral/info`,
        method: "GET"
      }),
      transformResponse: transformWithSpec(ReferralCommissionSettingsSpec)
    })
  };
}
export {
  publicReferralEndpoints as default
};
